{
  "nl": {
    "phase": {
      "attributes": {
        "end_date": "Einddatum",
        "internal_note": "Interne notitie",
        "name": "Naam",
        "start_date": "Startdatum"
      },
      "labels": {
        "phase": "Geen fase | Eén fase | {count} fasen"
      },
      "toasts": {
        "create": "Fase aangemaakt",
        "delete": "Fase verwijderd",
        "update": "Fase gewijzigd"
      },
      "validation": {
        "needName": "Titel is vereist",
        "needNumber": "Moet een getal zijn (bv. 85.5)"
      }
    }
  }
}